var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sun",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3434,4.929c0.39,0.39,0.39,1.023,0,1.414c-0.391,0.39-1.024,0.39-1.414,0 c-0.391-0.391-0.391-1.024,0-1.414C5.3194,4.538,5.9524,4.538,6.3434,4.929 M4.9294,19.071c0.39,0.391,1.023,0.391,1.414,0 c0.39-0.39,0.39-1.023,0-1.414c-0.391-0.39-1.024-0.39-1.414,0C4.5384,18.048,4.5384,18.681,4.9294,19.071 M19.0704,19.071 c0.391-0.39,0.391-1.023,0-1.414c-0.39-0.39-1.023-0.39-1.414,0c-0.39,0.391-0.39,1.024,0,1.414 C18.0474,19.462,18.6804,19.462,19.0704,19.071 M19.0704,4.929c-0.39-0.391-1.023-0.391-1.414,0c-0.39,0.39-0.39,1.023,0,1.414 c0.391,0.39,1.024,0.39,1.414,0C19.4614,5.952,19.4614,5.319,19.0704,4.929 M18.0004,12c0,3.313-2.687,6-6,6c-3.314,0-6-2.687-6-6 s2.686-6,6-6C15.3134,6,18.0004,8.687,18.0004,12 M16.0004,12c0-2.205-1.795-4-4-4c-2.206,0-4,1.795-4,4c0,2.206,1.794,4,4,4 C14.2054,16,16.0004,14.206,16.0004,12 M13.0004,4V3c0-0.553-0.448-1-1-1c-0.553,0-1,0.447-1,1v1c0,0.553,0.447,1,1,1 C12.5524,5,13.0004,4.553,13.0004,4 M13.0004,21v-1c0-0.553-0.448-1-1-1c-0.553,0-1,0.447-1,1v1c0,0.553,0.447,1,1,1 C12.5524,22,13.0004,21.553,13.0004,21 M4.0004,11h-1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1c0.552,0,1-0.447,1-1S4.5524,11,4.0004,11  M21.0004,11h-1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1c0.552,0,1-0.447,1-1S21.5524,11,21.0004,11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b3add505.svg";
export { ForwardRef as ReactComponent };